module.exports = __webpack_public_path__ + "static/media/empty_kudos.23e709bf.png";